import React from 'react';
import * as IconSet from "../../../../icons/index.js";
import Icon from "../../../basic/Icon/Icon.js";
import Tooltip from "../../../basic/Tooltip/Tooltip.js";
var TableHeaderTooltip = _ref => {
  var {
    id,
    text
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    className: "column-header-tooltip-icon",
    component: IconSet.Information,
    size: 14,
    "data-for": id,
    "data-tip": true
  }), /*#__PURE__*/React.createElement(Tooltip, {
    id: id,
    size: "small"
  }, text));
};
export default TableHeaderTooltip;